<mat-card class="full-width">
  <mat-card-title>Session Locked</mat-card-title>
  <mat-card-content>
    <p>Your session has been locked due to inactivity. Please enter your password to continue.</p>
    <form [formGroup]="form" (ngSubmit)="unlock()">
      <mat-form-field class="full-width">
        <mat-label>Password</mat-label>
        <input matInput type="password" formControlName="password">
      </mat-form-field>
      <mat-error *ngIf="invalid">Incorrect password</mat-error>
      <button mat-raised-button color="primary" type="submit">Unlock</button>
    </form>
  </mat-card-content>
</mat-card>